import React from 'react';
import ReactDOM from 'react-dom/client';
import { applyBrandToDocument } from './shared/brand';
import { startMonitoring } from './shared/monitoring/posthog-monitoring';
import './index.css';

applyBrandToDocument();
startMonitoring();

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found in index.html');
}

const root = ReactDOM.createRoot(rootEl);

void renderApplication();

async function renderApplication(): Promise<void> {
  if (
    import.meta.env.MODE === 'card-preset-lab' &&
    window.location.pathname === '/debug/card-preset-lab'
  ) {
    const { CardPresetLabPage } = await import('./features/dev/card-preset-lab/CardPresetLabPage');
    root.render(
      <React.StrictMode>
        <CardPresetLabPage />
      </React.StrictMode>,
    );
    return;
  }

  const [routerModule, queryModule, authModule, appModule] = await Promise.all([
    import('react-router-dom'),
    import('@tanstack/react-query'),
    import('./shared/auth/AuthProvider'),
    import('./App'),
  ]);
  const { BrowserRouter } = routerModule;
  const { QueryClient, QueryClientProvider } = queryModule;
  const { AuthProvider } = authModule;
  const { default: App } = appModule;
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: 1,
        refetchOnWindowFocus: false,
        staleTime: 5_000,
      },
    },
  });
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </React.StrictMode>,
  );
}
